import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { hasPermission, PERMISSIONS } from '../utils/rolePermissions';
import '../styles/Navbar.css';

const Navbar = () => {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Failed to log out:', error);
    }
  };

  if (!currentUser) {
    return null;
  }

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/dashboard" className="navbar-brand">
          <img src="/images/connectional-logo.svg" alt="Connectional" className="navbar-logo" />
        </Link>
        
        <div className="navbar-menu">
          <Link to="/dashboard" className="navbar-item">
            Dashboard
          </Link>
          
          <div className="navbar-dropdown">
            <button className="navbar-item dropdown-toggle">
              Candidates
              <span className="dropdown-arrow">▼</span>
            </button>
            <div className="dropdown-menu">
              <Link to="/candidates" className="dropdown-item">
                View All Candidates
              </Link>
              <Link to="/candidates/add" className="dropdown-item">
                Add New Candidate
              </Link>
              <Link to="/candidates/import" className="dropdown-item">
                Import Candidates
              </Link>
            </div>
          </div>

          <div className="navbar-dropdown">
            <button className="navbar-item dropdown-toggle">
              Education
              <span className="dropdown-arrow">▼</span>
            </button>
            <div className="dropdown-menu">
              <Link to="/course-of-study" className="dropdown-item">
                Course of Study
              </Link>
            </div>
          </div>

          <div className="navbar-dropdown">
            <button className="navbar-item dropdown-toggle">
              Reports & Submissions
              <span className="dropdown-arrow">▼</span>
            </button>
            <div className="dropdown-menu">
              <Link to="/reports" className="dropdown-item">
                Advanced Reports
              </Link>
              <Link to="/action-reports" className="dropdown-item">
                Action Reports
              </Link>
              <Link to="/reports/action-report-summary" className="dropdown-item">
                Action Report Summary
              </Link>
              <Link to="/reports/annual-conference" className="dropdown-item">
                Annual Conference Report
              </Link>
              <Link to="/submission-links" className="dropdown-item">
                Submission Links
              </Link>
              <Link to="/submission-template-editor" className="dropdown-item">
                Edit Portal Template
              </Link>
            </div>
          </div>

          {/* CRC Navigation - Archived (uncomment if needed) */}
          {/*
          {hasPermission(currentUser, PERMISSIONS.VIEW_CRC_REQUESTS) && (
            <div className="navbar-dropdown">
              <button className="navbar-item dropdown-toggle">
                CRC
                <span className="dropdown-arrow">▼</span>
              </button>
              <div className="dropdown-menu">
                <Link to="/crc/dashboard" className="dropdown-item">
                  CRC Dashboard
                </Link>
                <Link to="/crc/requests" className="dropdown-item">
                  View Requests
                </Link>
                {hasPermission(currentUser, PERMISSIONS.MANAGE_CRC_MEETINGS) && (
                  <Link to="/crc/meetings" className="dropdown-item">
                    Manage Meetings
                  </Link>
                )}
              </div>
            </div>
          )}
          */}

          {(() => {
            const isAdmin = currentUser?.role === 'Admin';
            const canManageReports = hasPermission(currentUser, PERMISSIONS.MANAGE_ACTION_REPORTS);
            if (!isAdmin && !canManageReports) return null;
            return (
              <div className="navbar-dropdown">
                <button className="navbar-item dropdown-toggle">
                  Administration
                  <span className="dropdown-arrow">▼</span>
                </button>
                <div className="dropdown-menu">
                  {isAdmin && (
                    <>
                      <Link to="/districts" className="dropdown-item">
                        Districts
                      </Link>
                      <Link to="/status-configuration" className="dropdown-item">
                        Status Configuration
                      </Link>
                    </>
                  )}
                  {canManageReports && (
                    <Link to="/admin/action-reports" className="dropdown-item">
                      Action Reports
                    </Link>
                  )}
                  {isAdmin && (
                    <>
                      <Link to="/user-management" className="dropdown-item">
                        User Management
                      </Link>
                      <Link to="/email-template-settings" className="dropdown-item">
                        Email Templates
                      </Link>
                    </>
                  )}
                </div>
              </div>
            );
          })()}
        </div>

        <div className="navbar-user">
          <div className="user-info">
            <span className="user-email">{currentUser.email}</span>
            <span className="user-role">{currentUser.role || 'Candidate'}</span>
          </div>
          <button onClick={handleLogout} className="logout-btn">
            Logout
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
